<template>
  <el-dialog title="Select & Fill Client Code Info" :close-on-click-modal="false" :visible.sync="visible" append-to-body width="700px">
    <el-form :model="dataForm" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="24" v-if="showItems.includes('companyName')">
          <el-form-item label="Company Name" prop="companyName">
            <el-input v-model="dataForm.companyName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showItems.includes('uen')">
          <el-form-item label="UEN" prop="uen">
            <el-input v-model="dataForm.uen" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showItems.includes('billingAddresses')">
          <el-form-item label="Billing Addresses" prop="billingInfoIndex">
            <el-select v-model="dataForm.billingInfoIndex" clearable filterable class="wdb100">
              <el-option
                v-for="(item, index) in billingInfoList"
                :key="`billing addresses-${index}`"
                :label="`${item.billingAddress || null} / ${item.billingCountry || null} / ${item.billingPostalCode || null}`"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="visible = false">Cancel</el-button>
      <el-button type="primary" size="medium" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    // 需要显示的自动填充项
    showItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        companyName: "",
        uen: "",
        billingInfoIndex: 0,
      },
      billingInfoList: [],
      dataRule: {},
    };
  },
  methods: {
    async init(data) {
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const dataCopy = JSON.parse(JSON.stringify(data));
      this.billingInfoList = dataCopy.billingInfoList || [];
      this.dataForm = {
        companyName: dataCopy.companyName,
        uen: dataCopy.uen,
        billingInfoIndex: 0,
      };
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          const params = {
            ...this.dataForm,
            billingInfoItem: this.billingInfoList[this.dataForm.billingInfoIndex],
          };
          this.$emit("selectedInfo", params);
          this.visible = false;
        }
      });
    },
  },
};
</script>
